package com.example.mystybag.appCore.model.pages

import com.example.mystybag.sharedmodels.project.responseModels.merchant.LocationRatingResponseModel
import com.example.mystybag.sharedmodels.project.responseModels.merchant.MerchantLocationResponseModel

data class MerchantLocationsListUIState(
    val isLoading: Boolean = false,
    val isStaff: Boolean = false,
    val locations: List<MerchantLocationResponseModel> = emptyList(),
    val ratingsByLocation: Map<Long, LocationRatingResponseModel> = emptyMap()
)
